import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { IState } from 'typings';

export const useThunkDispatch = () => {
  return useDispatch<ThunkDispatch<IState, null, Action>>();
};
